import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ProductRequests",
  "use": "ProductRequests-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ProductRequests\">\n  <path d=\"M19 3H4.99C3.88 3 3.01 3.9 3.01 5L3 19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 15H15C15 16.66 13.65 18 12 18C10.35 18 9 16.66 9 15H4.99V5H19V15ZM16 10H14V7H10V10H8L12 14L16 10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol